module.exports = __webpack_public_path__ + "static/media/MalcolmReynolds.b3770dee.png";